import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainLayout from "@/polymet/layouts/main-layout";
import HomePage from "@/polymet/pages/home-page";
import CategoryPage from "@/polymet/pages/category-page";
import SubcategoryPage from "@/polymet/pages/subcategory-page";
import ProductListingPage from "@/polymet/pages/product-listing-page";
import ProductDetailPage from "@/polymet/pages/product-detail-page";
import LoginPage from "@/polymet/pages/login-page";
import RegisterPage from "@/polymet/pages/register-page";
import AccountSetup from "@/polymet/pages/account-setup";
import UserProfilePage from "@/polymet/pages/user-profile-page";
import BuyerDashboard from "@/polymet/pages/buyer-dashboard";
import BrandsDirectoryPage from "@/polymet/pages/brands-directory-page";
import SuppliersDirectoryPage from "@/polymet/pages/suppliers-directory-page";
import BrandPage from "@/polymet/pages/brand-page";
import InquiryManagementPage from "@/polymet/pages/inquiry-management-page";
import SupplierProfilePage from "@/polymet/pages/supplier-profile-page";
import SupplierDashboard from "@/polymet/pages/supplier-dashboard";
import SupplierDashboardImproved from "@/polymet/pages/supplier-dashboard-improved";
import ProductCategoryPage from "@/polymet/pages/product-category-page";
import AddProductPage from "@/polymet/pages/add-product-page";
import AddBrandPage from "@/polymet/pages/add-brand-page";
import AdminPage from "@/polymet/pages/admin-page";
import BuyerRFQDashboard from "@/polymet/pages/buyer-rfq-dashboard";
import SupplierRFQDashboard from "@/polymet/pages/supplier-rfq-dashboard";
import RFQDetailPage from "@/polymet/pages/rfq-detail-page";
import SupplierOrderManagement from "@/polymet/pages/supplier-order-management";
import DashboardSelector from "@/polymet/pages/dashboard-selector";
import { RFQResponseForm } from "@/polymet/components/rfq-response-form";
import SearchResultsPage from "@/polymet/pages/search-results-page";
import { RFQForm } from "@/polymet/components/rfq-form";
import { AuthProvider } from "@/lib/auth-context";
import { ThemeProvider } from "@/lib/theme-context";
import { ProtectedRoute } from "@/lib/protected-route";
import ErrorBoundary from "@/polymet/components/ErrorBoundary";
import { AdminProtectedRoute } from "@/lib/admin-protected-route";
import { SupplierProtectedRoute } from "@/lib/supplier-protected-route";
import AdminSupplierEditPage from "@/polymet/pages/admin-supplier-edit-page";
import { CloudinaryUploadDemo } from "@/polymet/components/cloudinary-upload-demo";
import { CloudinaryConfigTest } from "@/polymet/components/cloudinary-config-test";
import SupplierProductAddPage from '@/polymet/pages/supplier-product-add-page';
import SupplierProductEditPage from '@/polymet/pages/supplier-product-edit-page';
import ProductTrackingTest from '@/polymet/components/product-tracking-test';

export default function MachineryMarketplacePrototype() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <ErrorBoundary>
            <Routes>
        <Route
          path="/"
          element={
            <MainLayout>
              <HomePage />
            </MainLayout>
          }
        />

        <Route
          path="/product-tracking-test"
          element={
            <MainLayout>
              <ProductTrackingTest />
            </MainLayout>
          }
        />

        <Route
          path="/:categoryId"
          element={
            <MainLayout>
              <CategoryPage />
            </MainLayout>
          }
        />

        <Route
          path="/:categoryId/:subCategoryId"
          element={
            <MainLayout>
              <SubcategoryPage />
            </MainLayout>
          }
        />

        <Route
          path="/:categoryId/:subCategoryId/:productCategoryId"
          element={
            <MainLayout>
              <ProductListingPage />
            </MainLayout>
          }
        />

        <Route
          path="/products"
          element={
            <MainLayout>
              <ProductCategoryPage />
            </MainLayout>
          }
        />

        {/* Redirect /product (without slug) to product category page */}
        <Route
          path="/product"
          element={
            <MainLayout>
              <ProductCategoryPage />
            </MainLayout>
          }
        />

        <Route
          path="/product/:slug"
          element={
            <MainLayout>
              <ProductDetailPage />
            </MainLayout>
          }
        />

        {/* Legacy route for backward compatibility */}
        <Route
          path="/products/:slug"
          element={
            <MainLayout>
              <ProductDetailPage />
            </MainLayout>
          }
        />

        <Route
          path="/brands"
          element={
            <MainLayout>
              <BrandsDirectoryPage />
            </MainLayout>
          }
        />

        <Route
          path="/brands/:brandId"
          element={
            <MainLayout>
              <BrandPage />
            </MainLayout>
          }
        />
        
        <Route
          path="/brands/slug/:brandSlug"
          element={
            <MainLayout>
              <BrandPage />
            </MainLayout>
          }
        />

        <Route
          path="/suppliers"
          element={
            <MainLayout>
              <SuppliersDirectoryPage />
            </MainLayout>
          }
        />

        <Route
          path="/search"
          element={
            <MainLayout>
              <SearchResultsPage />
            </MainLayout>
          }
        />

        <Route
          path="/login"
          element={
            <MainLayout>
              <ProtectedRoute requireAuth={false}>
                <LoginPage />
              </ProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/register"
          element={
            <MainLayout>
              <ProtectedRoute requireAuth={false}>
                <RegisterPage />
              </ProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/account-setup"
          element={
            <MainLayout>
              <ProtectedRoute>
                <AccountSetup />
              </ProtectedRoute>
            </MainLayout>
          }
        />
        
        <Route
          path="/account"
          element={
            <MainLayout>
              <ProtectedRoute>
                <UserProfilePage />
              </ProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/dashboard"
          element={
            <MainLayout>
              <ProtectedRoute>
                <DashboardSelector />
              </ProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/buyer-dashboard"
          element={
            <MainLayout>
              <ProtectedRoute>
                <BuyerDashboard />
              </ProtectedRoute>
            </MainLayout>
          }
        />
        
        <Route
          path="/buyer-dashboard/rfqs"
          element={
            <MainLayout>
              <ProtectedRoute>
                <BuyerRFQDashboard />
              </ProtectedRoute>
            </MainLayout>
          }
        />
        
        <Route
          path="/buyer-dashboard/rfqs/:rfqId"
          element={
            <MainLayout>
              <ProtectedRoute>
                <RFQDetailPage />
              </ProtectedRoute>
            </MainLayout>
          }
        />
        
        <Route
          path="/create-rfq"
          element={
            <MainLayout>
              <ProtectedRoute>
                <div className="container mx-auto py-8 px-4">
                  <h1 className="text-3xl font-bold mb-6">Create New RFQ</h1>
                  <RFQForm />
                </div>
              </ProtectedRoute>
            </MainLayout>
          }
        />
        
        <Route
          path="/edit-rfq/:rfqId"
          element={
            <MainLayout>
              <ProtectedRoute>
                <div className="container mx-auto py-8 px-4">
                  <h1 className="text-3xl font-bold mb-6">Edit RFQ</h1>
                  <RFQForm isEditing={true} />
                </div>
              </ProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/inquiry-management"
          element={
            <MainLayout>
              <ProtectedRoute>
                <InquiryManagementPage />
              </ProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/inquiry-management/:inquiryId"
          element={
            <MainLayout>
              <ProtectedRoute>
                <InquiryManagementPage />
              </ProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/suppliers/:slug"
          element={
            <MainLayout>
              <SupplierProfilePage />
            </MainLayout>
          }
        />

        <Route
          path="/supplier/:slug"
          element={
            <MainLayout>
              <SupplierProfilePage />
            </MainLayout>
          }
        />

        <Route
          path="/supplier-dashboard"
          element={
            <MainLayout>
              <SupplierProtectedRoute>
                <SupplierDashboardImproved />
              </SupplierProtectedRoute>
            </MainLayout>
          }
        />

        {/* Redirect /seller-dashboard to /supplier-dashboard for backwards compatibility */}
        <Route
          path="/seller-dashboard"
          element={
            <MainLayout>
              <SupplierProtectedRoute>
                <SupplierDashboardImproved />
              </SupplierProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/supplier-dashboard/rfqs"
          element={
            <MainLayout>
              <SupplierProtectedRoute>
                <SupplierRFQDashboard />
              </SupplierProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/supplier-dashboard/rfqs/:rfqId"
          element={
            <MainLayout>
              <SupplierProtectedRoute>
                <div className="container mx-auto py-8 px-4">
                  <h1 className="text-3xl font-bold mb-6">RFQ Details & Response</h1>
                  {/* Pass the rfqId from the URL params */}
                  <RFQResponseForm rfqId={window.location.pathname.split('/').pop()} />
                </div>
              </SupplierProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/supplier-dashboard/quotes/:responseId"
          element={
            <MainLayout>
              <SupplierProtectedRoute>
                <div className="container mx-auto py-8 px-4">
                  <h1 className="text-3xl font-bold mb-6">Quote Details</h1>
                  {/* TODO: Create a QuoteDetailPage component */}
                  <p>Quote detail view will be implemented here</p>
                </div>
              </SupplierProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/supplier-dashboard/quotes/:responseId/edit"
          element={
            <MainLayout>
              <SupplierProtectedRoute>
                <div className="container mx-auto py-8 px-4">
                  <h1 className="text-3xl font-bold mb-6">Update Quote</h1>
                  {/* Pass responseId from URL params and set isEditing to true */}
                  <RFQResponseForm 
                    responseId={window.location.pathname.split('/')[3]} 
                    isEditing={true} 
                  />
                </div>
              </SupplierProtectedRoute>
            </MainLayout>
          }
        />
        
        <Route
          path="/supplier/orders/:orderId"
          element={
            <MainLayout>
              <SupplierProtectedRoute>
                <SupplierOrderManagement />
              </SupplierProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/sell"
          element={
            <MainLayout>
              <SupplierProtectedRoute>
                <SupplierDashboard />
              </SupplierProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/add-product"
          element={
            <MainLayout>
              <ProtectedRoute>
                <AddProductPage />
              </ProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/add-brand"
          element={
            <MainLayout>
              <ProtectedRoute>
                <AddBrandPage />
              </ProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/supplier/products/add"
          element={
            <MainLayout>
              <SupplierProtectedRoute>
                <SupplierProductAddPage />
              </SupplierProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/supplier/products/edit/:productId"
          element={
            <MainLayout>
              <SupplierProtectedRoute>
                <SupplierProductEditPage />
              </SupplierProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/admin"
          element={
            <MainLayout>
              <AdminProtectedRoute>
                <AdminPage />
              </AdminProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/admin/supplier/:supplierSlug"
          element={
            <MainLayout>
              <AdminProtectedRoute>
                <AdminSupplierEditPage />
              </AdminProtectedRoute>
            </MainLayout>
          }
        />

        <Route
          path="/cloudinary-upload-demo"
          element={
            <MainLayout>
              <CloudinaryUploadDemo />
            </MainLayout>
          }
        />

        <Route
          path="/cloudinary-config-test"
          element={
            <MainLayout>
              <CloudinaryConfigTest />
            </MainLayout>
          }
        />

        <Route
          path="/product-tracking-test"
          element={
            <MainLayout>
              <ProductTrackingTest />
            </MainLayout>
          }
        />
      </Routes>
          </ErrorBoundary>
      </Router>
    </ThemeProvider>
  </AuthProvider>
  );
}
